module.exports = __webpack_public_path__ + "static/media/201EC164.464c9da3.jpg";